import { useHistory } from "react-router-dom";
import "./CommonBannerComponent.scss";
import { connect } from "react-redux";
import uiActions from "../../../../../redux/ui/action";
import axios from "axios";
import { url_213 } from "../../../../../custom_utilities/api_services";
import { useEffect, useState } from "react";
import userActivityActions from "../../../../../redux/user_activity/action";

const CommonBannerComponent = (props) => {
  let { tab, startLoading, finishLoading, setCommonBannerData } = props;

  const [state, setState] = useState({
    data: {},
  });

  useEffect(() => {
    getAttemptDetails();
  }, []);

  const getPaperType = () => {
    const tabToPaperType = {
      adaptive_cps: 4,
      cps: 2,
      "Exam Cracker - JEE Main": 9,
      "Exam Cracker - JEE Advanced": 8,
      "Exam Cracker - NEET": 6,
    };
    return tabToPaperType[tab];
  };

  const getAttemptDetails = async () => {
    startLoading();
    try {
      const response = await axios.get(
        `${url_213}/?paper_type=${getPaperType()}`
      );
      if (response.data.status === 200) {
        finishLoading();
        setState(() => ({
          ...state,
          data: response.data.data,
        }));
        setCommonBannerData({
          ...state,
          data: response.data.data,
        });
      }
    } catch (error) {
      console.log(error);
      finishLoading();
    }
  };

  const history = useHistory();

  const width = tab.includes("Exam Cracker") ? "68%" : "100%";

  const handleButtonClick = () => {
    history.push({ pathname: "/store", state: { tab: "online_learning" } });
  };

  return (
    <>
      {tab.includes("Exam Cracker") && !state.data.package_active && (
        <div
          className="common_promo_banner d-flex align-items-center"
          style={{ width: width, margin: "auto" }}
        >
          <div>
            <p>Exam Mastery</p>
            <p>
              Your path to exam success begins with ‘Exam Cracker’. <br />
              Subscribe now!
            </p>
          </div>
          <div>
            <button onClick={handleButtonClick}>Buy Now</button>
          </div>
        </div>
      )}
      {(tab === "/cps" || tab === "/adaptive_cps") &&
        !state.data.package_active && (
          <div className="common_promo_banner d-flex align-items-center">
            <div>
              {state.data.is_attempt > 0 ? (
                <>
                  <p>Enjoy your Free Trial attempts</p>
                  <span>{state.data.is_attempt} Left</span>
                </>
              ) : (
                <p>No free attempts left</p>
              )}
              {tab === "/cps" ? (
                <p>
                  Upgrade now for unlimited access and unlock the full potential
                  of Conceptual Problem Sheets.
                </p>
              ) : (
                <p>
                  Upgrade now for unlimited access and unlock the full potential
                  of Adaptive CPS.
                </p>
              )}
            </div>
            <div>
              <button onClick={handleButtonClick}>Get Now</button>
            </div>
          </div>
        )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
    setCommonBannerData: (payload) => {
      dispatch(userActivityActions.setCommonBannerData(payload));
    },
  };
};

export default connect(0, mapDispatchToProps)(CommonBannerComponent);
